























import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';

@Component
export default class NoScanner extends Vue {
  @Prop({ default: 'Enter Product ID'}) public customFieldLabel!: string;
  @Prop({ default: 'Verify now'}) public customButtonLabel!: string;
  @Prop({ default: false}) public customButtonLoading!: boolean;
  @Prop({ default: 'PUBLIC_KEY'}) public keyType!: string;

  public valid = true;
  public key = '';

  public rules = {
    required: (value: string) => !!value || 'Required.',
    validURL: (value: string) => this.isUrlValidFormat(value) || 'Not valid url',
    addresslength: (value: string) => value.length === 40 || 'Not valid address',
    publickeylength: (value: string) => value.length === 64 || 'Not valid public key',
    privatekeylength: (value: string) => (value.length === 64 || value.length === 66) || 'Not valid private key',
    addresspattern: (value: string) => {
      value = value.toString().toUpperCase().replace(/-/g, '');
      // TODO: implement address check
      // https://github.com/QuantumMechanics/NEM-sdk/blob/master/src/model/address.js#L127
      return true || 'Invalid address pattern.';
    },
    hexpattern: (value: string) => {
      const pattern = /^(0x|0X)?[a-fA-F0-9]+$/;
      return pattern.test(value) || 'Invalid hex pattern.';
    }
  };

  public isUrlValidFormat(url: string) {
    return /^https?:\/\//i.test(url);
  }

  public submit() {
    if ((this.$refs.form as HTMLFormElement).validate()) {
      this.$emit('decode', this.key);
    }
  }

  get btnDissable() {
    if (this.valid) {
      if (this.customButtonLoading) {
        return true;
      } else {
        return false;
      }
    } else {
      return true;
    }
  }

  get noScannerRules() {
    return [this.rules.required, this.rules.validURL];
    // if (this.keyType === 'PUBLIC_KEY') {
    //   return true;
    //   return [this.rules.required, this.rules.publickeylength, this.rules.hexpattern];
    // } else if (this.keyType === 'PRIVATE_KEY') {
    //   return true;
    //   // return [this.rules.required, this.rules.privatekeylength, this.rules.hexpattern];
    // } else if (this.keyType === 'ADDRESS') {
    //   return true;
    //   // return [this.rules.required, this.rules.addresslength, this.rules.addresspattern];
    // }
  }
}
